import $ from "jquery";

// https://developers.google.com/maps/documentation/javascript/examples/poly-containsLocation
// https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete

// This example requires the Geometry library. Include the libraries=geometry
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=geometry">

export default function pizzeria_search_input() {
  function updateDeliveryAreas(pizzerias) {
    for (var i = 0; i < pizzerias.length; i++) {
      let p = pizzerias[i];
      if (p.delivery_area.length) {
        var polygon = [];
        let delivery_area = JSON.parse(p.delivery_area);
        delivery_area.forEach(function(el) {
          polygon.push({ lat: el[0], lng: el[1] });
        });
        var deliveryArea = new google.maps.Polygon({
          paths: polygon,
          strokeColor: "#72BF44",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#72BF44",
          fillOpacity: 0.35
        });
        // replace delivery area with google map polygon
        p.delivery_area = deliveryArea;
      }
    }
    return pizzerias;
  }

  function drawDeliveryAreasOnMap(pizzerias, map) {
    pizzerias.forEach(function(pizzeria) {
      if (typeof pizzeria.delivery_area === "object") {
        pizzeria.delivery_area.setMap(map);
      }
    });
  }

  function buildDestinations(pizzerias) {
    var destinations = [];
    pizzerias.forEach(pizzeria => {
      destinations.push(`{ lat: ${pizzeria.lat}, lng: ${pizzeria.lng} }`);
    });
    return destinations;
  }
  // closest 3
  function addDistanceAndDuration(pizzerias, place) {
    var origin = {};
    var newPizzerias = [];
    origin.lat = place.lat();
    origin.lng = place.lng();

    pizzerias.forEach(pizzeria => {
      var destination = {};
      destination.lat = parseFloat(pizzeria.lat);
      destination.lng = parseFloat(pizzeria.lng);

      var service = new google.maps.DistanceMatrixService();
      var options = {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
        unitSystem: google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false
      };
      service.getDistanceMatrix(options, function(response, status) {
        if (status == "OK") {
          pizzeria.distance = response.rows[0].elements[0].distance;
          pizzeria.duration = response.rows[0].elements[0].duration;

          newPizzerias.push(pizzeria);

          if (pizzeria.distance != null) {
            if (pizzerias.length == newPizzerias.length) {
              let sortedPizzerias = sortPizzerias(newPizzerias);
              showNearbyPizzerias(sortedPizzerias);
              document.querySelector(".pizzeria-list").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
            }
          } else {
            if (pizzerias.length == newPizzerias.length) {
              noResults();
            }
          }
        }
      });
    });
  }

  function noResults() {
    $(".pizzeria-list li").remove();
    const $pizzeriaList = $(".pizzeria-list");
    var $html = "<li class='no-results text'>";
    $html += "<h3>No Results Found</h3>";
    $html += "</li>";
    $pizzeriaList.append($html);
  }

  function deliveryArea(pizzerias, place) {
    pizzerias.forEach(pizzeria => {
      if (typeof pizzeria.delivery_area === "object") {
        // this just checks stores with polygons still need to check location against lat and lng to see how far origin is from dest
        if (
          google.maps.geometry.poly.containsLocation(
            place,
            pizzeria.delivery_area
          )
        ) {
          pizzeria.inDeliveryArea = true;
        } else {
          pizzeria.inDeliveryArea = false;
        }
      }
    });
    return pizzerias;
  }

  function showNearbyPizzerias(pizzerias) {
    let closestPizzerias = pizzerias.slice(0, 3);
    const $pizzeriaList = $(".pizzeria-list");
    const $pizzeriaListLis = $(".pizzeria-list li");
    $pizzeriaListLis.remove();
    closestPizzerias.forEach(pizzeria => {
      let $html = `<li class='pizzeria-list__item' data-pizzeria="${pizzeria.slug}">`;
      $html += `<div class="border">`;
      $html += `<div class="pizzeria-image"><h3>${pizzeria.title}</h3><div class="image" style="background-image: url(${pizzeria.image_url});"></div></div>`;
      $html += `<div class="pizzeria-text text">`;
      $html += `<div>${pizzeria.street_address}</div>`;
      $html += `<div class="pizzeria-meta"><span class="distance">Distance: ${pizzeria.distance.text}</span>`;
      if (pizzeria.inDeliveryArea) {
        $html += `<span class="delivery-area">In Delivery Area</span>`;
      }
      $html += `</div>`;
      $html += `</div>`;
      $html += `</div>`;
      $html += `</li>`;
      $pizzeriaList.append($html);
    });
  }

  function sortPizzerias(pizzerias) {
    var sortable = pizzerias;
    sortable.sort(function(a, b) {
      if (a.distance.value != undefined && b.distance.value != undefined) {
        return a.distance.value - b.distance.value;
      }
    });
    return sortable;
  }

  function initStoreLocatorMap() {
    var pizzerias = $("#store-locator-map").data("pizzerias");
    var place;
    var map;
    var input;
    var autocomplete;

    map = new google.maps.Map(document.getElementById("store-locator-map"), {
      center: { lat: -36.848653, lng: 174.756968 },
      zoom: 10
    });

    input = document.querySelector(".search__area-code input");
    autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "nz" }
    });

    autocomplete.bindTo("bounds", map);
    autocomplete.setFields(["address_components", "geometry", "icon", "name"]);
    autocomplete.addListener("place_changed", function() {
      place = autocomplete.getPlace();
      place = place.geometry.location;
    });

    pizzerias = updateDeliveryAreas(pizzerias, map);
    drawDeliveryAreasOnMap(pizzerias, map);

    $(".search__area-code-go").on("click", () => {
      pizzerias = deliveryArea(pizzerias, place);
      // updateStoreList(pizzerias);
      addDistanceAndDuration(pizzerias, place);
    });
  }

  if ($(".pizzeria-search").length) {
    initStoreLocatorMap();
  }
}
